import React from 'react';
import Grid2 from "@mui/material/Grid2";
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import {ListItem} from "@mui/material";
import {useSxStyles as sx} from "../styles/sxStyles";


const Legal = () => {


    return (
        (<Grid2 container spacing={1} sx={sx.text}>
            < Grid2 sx={sx.gridCopyright} size={12}>
                <Typography variant='h6' sx={sx.textCopyright}>
                    {'Copyright'}
                </Typography>
            </Grid2>
            < Grid2 style={{paddingTop: "1rem"}} size={12}>
                <Typography component='span' sx={sx.bold}>Copyright:</Typography> All content on this web site, such as text, graphics, logos, button icons and images is the
                property of Justice Systems, Inc. or its content suppliers and protected by United States and
                international copyright laws. The selection, arrangement, and presentation of all materials on this web
                site (including information in the public domain), and the overall design of this web site is the
                exclusive property of Justice Systems, Inc. and protected by United States and international copyright
                laws. All software on this site is the property of Justice Systems, Inc. or its software suppliers and
                protected by United States and international copyright laws.

            </Grid2>
            <Grid2 size={12} >
                <Typography component='span' sx={sx.bold}>Trademarks:</Typography> NEUMO payments graphics, logos, page headers, button icons, scripts and service names are
                trademarks or trade dress of Justice Systems, Inc. and such trademarks and trade dress may not be used
                in connection with any product or service of Justice Systems, Inc., in any manner that is likely to cause
                confusion among customers, or in any manner that disparages or discredits Justice Systems, Inc., its
                products or services or this web site. All other trademarks not owned by Justice Systems, Inc. that
                appear on this site are the property of their respective owners, who may or may not be affiliated with,
                connected to, or sponsored by Justice Systems, Inc.
            </Grid2>
            <Grid2 size={12} >
                <Typography component='span' sx={sx.bold}>Legal Notices:</Typography> Portions of this software are:
                <List>
                    <ListItem sx={sx.listItem}>FullCourt Enterprise © 2006-2021 Justice Systems, Inc. – All Rights Reserved.</ListItem>
                    <ListItem sx={sx.listItem}>FullCourt © 1985-2021 Justice Systems, Inc. – All Rights Reserved</ListItem>
                    <ListItem sx={sx.listItem}>Copyright © 1999, 2006 Tanuki Software, Inc.</ListItem>
                    <ListItem sx={sx.listItem}>Copyright © 2001 Silver Egg Technology</ListItem>
                    <ListItem sx={sx.listItem}>Copyright 1999-2007, The Apache Software Foundation (<Link href="http://www.apache.org">http://www.apache.org</Link>)</ListItem>
                    <ListItem sx={sx.listItem}>Copyright 2007, Free Software Foundation, Inc. (<Link href="http://fsf.org">http://fsf.org</Link>)</ListItem>
                </List>
            </Grid2>
            <Grid2 size={12} >
                THIS SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND OTHER
                THAN AS SPECIFICALLY SET FORTH IN THE LICENSE AGREEMENT, INCLUDING
                WITHOUT LIMITATION WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
                OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
            </Grid2>
        </Grid2>)
    );
};

export default Legal;
